import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Wrap } from 'shared/components/Base/Base'
import { Button } from 'shared/components/Button/Button'
import { SimpleDialog } from 'shared/components/Dialog/SimpleDialog'
import { ExternalLink } from 'shared/components/ExternalLink/ExternalLink'
import { TextV2 } from 'shared/components/Text/TextV2'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

import { useErrorMessage } from '../../hooks/useErrorMessage'
import { acceptStripeCardholderComplianceTerms } from '../../models/stripe'
import { getUserAndTeammateInfo } from '../../redux/actions/users/actions'
import { currentUserSelector, isVendorUserSelector } from '../../redux/selectors/users'
import { ApplicationState, ReduxDispatch } from '../../redux/store/models'
import { COMPANY_PATH, CONTRACTOR_PAYMENTS_PATH, MOBILE_AUTH_PATH } from '../../Routes'

export function StripeTosModal() {
  const dispatch: ReduxDispatch = useDispatch()
  const isVendorUser = useSelector(isVendorUserSelector)
  const user = useSelector(currentUserSelector)
  const authUser = useSelector((state: ApplicationState) => state.auth.isAuthenticated)
  const { pathname } = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const showErrorMessage = useErrorMessage()

  if (user.is_staff || (user.can_operate_fleet && !user.is_team_driver)) return null

  if (
    !authUser ||
    !user.team ||
    pathname === '/manage' ||
    pathname.startsWith('/manage/') ||
    pathname === COMPANY_PATH.slice(0, -1) ||
    pathname.startsWith(COMPANY_PATH)
  )
    return null
  if (
    pathname.includes('registration') ||
    pathname.includes(MOBILE_AUTH_PATH) ||
    pathname.includes(CONTRACTOR_PAYMENTS_PATH)
  )
    return null
  if (user.has_recorded_terms_on_stripe || isVendorUser) return null

  async function handleAccept() {
    setIsLoading(true)
    try {
      await acceptStripeCardholderComplianceTerms(user.id)
      await dispatch(getUserAndTeammateInfo())
    } catch (err) {
      showErrorMessage(err)
    }
    setIsLoading(false)
  }

  return (
    <SimpleDialog isOpen>
      <Wrap maxWidth="100%">
        <TextV2 type={TYPOGRAPHY.header2} className="text-left">
          Terms of Service update
        </TextV2>
        <TextV2 type={TYPOGRAPHY.paragraph1} className="text-mid-gray mt-2 mb-8 text-left">
          Our Terms of Service have been updated. To continue using CloudTrucks, please review and accept the
          new{' '}
          <ExternalLink href="https://www.cloudtrucks.com/terms" variant="paragraph1">
            Terms of Service
          </ExternalLink>
          .
        </TextV2>
        <Button margin="0 auto" variant="primary" size="large" onClick={handleAccept} isLoading={isLoading}>
          Accept
        </Button>
      </Wrap>
    </SimpleDialog>
  )
}
